import { FC } from 'react'
import { Helmet } from 'react-helmet-async'
import { aboutLeadershipPath, absoluteUrl } from 'lib/urls'
import AboutLeadership from './components/AboutLeadership'

const AboutLeadershipRoute: FC = () => {
  const title = 'Leadership Team | Babylist Inc.'
  const description =
    "Babylist's executive leadership team includes industry experts in our core business areas. Meet our leaders."

  return (
    <div>
      <Helmet prioritizeSeoTags>
        <title>{title}</title>
        <meta content={title} property="og:title" />
        <meta content={description} name="description" />
        <meta content={description} property="og:description" />
        <link href={absoluteUrl(aboutLeadershipPath)} rel="canonical" />
      </Helmet>
      <AboutLeadership />
    </div>
  )
}

export default AboutLeadershipRoute
